import ReliableWebSocket, {
  type ReliableWebSocketOptions,
} from '@cdc-internal/fe-toolbox/libs/reliable-websocket'

import { logger } from '@/configs'
import { currentAppEnvConfigs } from '@/configs/env'

// SEE https://mcoproduct.atlassian.net/wiki/spaces/C/pages/1373798547/Token+Price+REST+WebSocket+API#WebSocket-(%2Fv2)
const WSSUrl = `wss://${currentAppEnvConfigs.priceStreamDomain}/ws/v2`
const TOKEN_PRICE_TOPIC = 'token_price'

export interface SubscribeParams {
  slugs: string[]
}

export default class PriceWebSocket extends ReliableWebSocket {
  constructor(public topic = TOKEN_PRICE_TOPIC) {
    const heartbeatOptions: ReliableWebSocketOptions['heartbeatOptions'] = {
      pingData: JSON.stringify({
        jsonrpc: '2.0',
        method: 'ping',
      }),
      pongCheck: data => {
        try {
          const msg = JSON.parse(data as string)
          return msg?.method === 'ping' && msg?.result?.status === 'ok'
        } catch (error) {
          return false
        }
      },
    }
    super(WSSUrl, {
      heartbeatOptions,
    })
  }

  subscribe<T>(params: SubscribeParams, cb: (message: T) => void) {
    const _subscribe = () =>
      this.send(
        JSON.stringify({
          jsonrpc: '2.0',
          method: 'subscribe',
          params: {
            topic: this.topic,
            ...params,
          },
        }),
      )
    this.onopen = _subscribe
    if (this.readyState === WebSocket.OPEN) {
      _subscribe()
    }

    this.onmessage = (event: MessageEvent) => {
      try {
        const jsonData = JSON.parse(event.data)
        if (jsonData.result.data) {
          cb(jsonData.result.data)
        }
      } catch (e) {
        logger.error('PriceWebSocket error', e)
      }
    }
  }

  unsubscribe() {
    this.send(
      JSON.stringify({
        jsonrpc: '2.0',
        method: 'unsubscribe',
        params: {
          topic: this.topic,
        },
      }),
    )
  }
}
